import React from 'react';
import { Link } from 'react-router-dom';
import { FiServer, FiMail, FiFileText, FiSettings, FiDollarSign } from 'react-icons/fi';

export default function Sidebar({ activeTab, setActiveTab }) {
  const menuItems = [
    { id: 'accounts', label: 'Hosting Accounts', icon: FiServer, href: '/hosting' },
    { id: 'emails', label: 'Email Accounts', icon: FiMail, href: '/emails' },
    { id: 'files', label: 'File Manager', icon: FiFileText, href: '/files' },
    { id: 'billing', label: 'Billing', icon: FiDollarSign, href: '/billing' },
    { id: 'settings', label: 'Settings', icon: FiSettings, href: '/settings' },
  ];

  return (
    <aside className="w-64 bg-gray-900 text-white h-screen overflow-y-auto sticky top-16">
      <nav className="p-4 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.id}
              to={item.href}
              onClick={() => setActiveTab(item.id)}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                activeTab === item.id
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-800'
              }`}
            >
              <Icon size={20} />
              <span className="font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
